import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from "@mui/material"
import { BiData, BiFile } from "react-icons/bi"

import { UploadFile } from "@/type"

export const DroppedFileConfirmationModal = (props: {
	isOpen: boolean
	onClose: (result: boolean) => void
	uploadFile: UploadFile | null
	isButtonLoading: boolean
}) => {
	if (props.uploadFile == null) {
		return <></>
	}
	return (
		<Dialog open={props.isOpen} onClose={() => props.onClose(false)} aria-label="upload modal">
			<DialogTitle>CSVファイルから行を追加</DialogTitle>
			<DialogContent>
				<Stack direction="row" alignItems="center" spacing={0.5}>
					<BiFile />
					<Typography>{props.uploadFile.fileName} から</Typography>
				</Stack>
				<Stack direction="row" alignItems="center" spacing={0.5}>
					<BiData />
					<Typography>{props.uploadFile.tableName} テーブルに行を追加します。</Typography>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.onClose(false)} disabled={props.isButtonLoading}>
					追加しない
				</Button>
				<Button onClick={() => props.onClose(true)} disabled={props.isButtonLoading}>
					追加する {props.isButtonLoading ? <CircularProgress size={24} style={{ marginLeft: "0.5em" }} /> : <></>}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
